import { useTranslation } from 'react-i18next'
import {
  StyledBar,
  StyledTitleWrapper,
  StyledIcon,
  StyledCloseIcon,
  StyledLink,
  StyledWarningCheck,
} from './styled'
import IconInfo from '~/assets/images/exclamation-mark-blue.svg'
import IconWarning from '~/assets/images/warning-alert.svg'
import IconRisk from '~/assets/images/risk-alert.svg'
import IconClose from '~/assets/images/modal-close.svg'

export type NotificationLevel = 'info' | 'warning' | 'risk' | 'verified'

interface NotificationBarProps {
  text: React.ReactNode
  level?: NotificationLevel
  linkText?: string
  showIcon?: boolean
  showLink?: boolean
  showClose?: boolean
  handleClose?: () => void
  handleLinkClick?: () => void
  style?: React.CSSProperties
  showCheckBox?: boolean
  checked?: boolean
  setChecked?: (value: boolean) => void
}

const NotificationBar: React.FC<NotificationBarProps> = ({
  text,
  level = 'info',
  linkText,
  showIcon = true,
  showLink = true,
  showClose = true,
  showCheckBox = false,
  handleClose,
  handleLinkClick,
  style,
  checked,
  setChecked,
}) => {
  const { t } = useTranslation()

  const levelIcons = {
    info: IconInfo,
    warning: IconWarning,
    risk: IconRisk,
    verified: IconInfo,
  }

  return (
    <StyledBar level={level} style={style}>
      <StyledTitleWrapper>
        {showIcon && <StyledIcon src={levelIcons[level]} />}
        {showCheckBox && (
          <StyledWarningCheck
            htmlFor="notification-checkbox"
            onClick={() => {
              setChecked?.(!checked)
            }}
            level={level}
          >
            <input
              type="checkbox"
              name="notification-checkbox"
              checked={checked}
              readOnly
            />
            <span className="checkmark" />
          </StyledWarningCheck>
        )}
        <div>
          <span>{text}</span>
          &nbsp;
          {showLink && (
            <StyledLink onClick={handleLinkClick}>
              {linkText ?? `${t('learn_more')} >`}
            </StyledLink>
          )}
        </div>
      </StyledTitleWrapper>
      {showClose && <StyledCloseIcon src={IconClose} onClick={handleClose} />}
    </StyledBar>
  )
}

export default NotificationBar
